/* index.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._313842dnbC%7Bmargin-top%3A0%7D%0A._0adFHsIZbP%7Bmargin-right%3Aauto%7D%0A._1DCdHidnbC%7Bmargin-bottom%3A0%7D%0A._2XsHFMIZbP%7Bmargin-left%3Aauto%7D%0A._1EqgXlN91d%7Bmax-width%3A100%25%7D%0A._0NUa3rBM7N%7Bmax-height%3A70vh%7D%0A._00EA0egIor%7B-o-object-fit%3Acontain%3Bobject-fit%3Acontain%7D%0A._3iDTPbvLZJ%7Bdisplay%3Ablock%7D%0A._2mHwu85zaO%7Bgap%3Avar(--ds-space-200%2C1pc)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._37wbyuDIqT%7Bjustify-content%3Acenter%7D%0A._0Of8r2Va5s%7Bpadding-top%3Avar(--ds-space-400%2C2pc)%7D%0A._1ZnuxbVa5s%7Bpadding-right%3Avar(--ds-space-400%2C2pc)%7D%0A._1wydGWVa5s%7Bpadding-bottom%3Avar(--ds-space-400%2C2pc)%7D%0A._2Zuz6QVa5s%7Bpadding-left%3Avar(--ds-space-400%2C2pc)%7D%0A._4kiQYAgZxp%7Bmin-height%3A200px%7D%0A._4bt5LAIZbP%7Boverflow-x%3Aauto%7D%0A._2WAcuGIZbP%7Boverflow-y%3Aauto%7D%0A._0bjKvDKxmn%7Bborder-radius%3Avar(--ds-radius-small%2C4px)%7D%0A._2sNsIgNxAV%7Bfont%3Avar(--ds-font-code%2Cnormal%20400%20.875em%2F1%20%22Atlassian%20Mono%22%2Cui-monospace%2CMenlo%2C%22Segoe%20UI%20Mono%22%2C%22Ubuntu%20Mono%22%2Cmonospace)%7D%0A._0NUa3rhLcO%7Bmax-height%3A80vh%7D%0A._0Of8r25zaO%7Bpadding-top%3Avar(--ds-space-200%2C1pc)%7D%0A._1Znuxb5zaO%7Bpadding-right%3Avar(--ds-space-200%2C1pc)%7D%0A._1wydGW5zaO%7Bpadding-bottom%3Avar(--ds-space-200%2C1pc)%7D%0A._2Zuz6Q5zaO%7Bpadding-left%3Avar(--ds-space-200%2C1pc)%7D%0A._0KLXruDMqu%7Bbackground-color%3Avar(--ds-background-neutral%2C%230515240f)%7D%0A._1ANEUSlpBW%7Bwhite-space%3Apre-wrap%7D%0A._3W2Oc8wPeg%7Bword-break%3Abreak-word%7D%0A._4kiQYAHakr%7Bmin-height%3A25pc%7D");






























import React, { useEffect, useState } from 'react';
import type { IntlShape, MessageDescriptor } from 'react-intl';
import ModalBody from '@atlaskit/modal-dialog/modal-body';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import ModalHeader from '@atlaskit/modal-dialog/modal-header';
import ModalTitle from '@atlaskit/modal-dialog/modal-title';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Text } from '@atlaskit/primitives/compiled/text';
import Spinner from '@atlaskit/spinner/spinner';
const styles = {
  filePreviewImage: "_313842dnbC _0adFHsIZbP _1DCdHidnbC _2XsHFMIZbP _1EqgXlN91d _0NUa3rBM7N _00EA0egIor _3iDTPbvLZJ",
  filePreviewFallback: "_2mHwu85zaO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT _37wbyuDIqT _0Of8r2Va5s _1ZnuxbVa5s _1wydGWVa5s _2Zuz6QVa5s _4kiQYAgZxp",
  filePreviewTextContent: "_4bt5LAIZbP _2WAcuGIZbP _0bjKvDKxmn _2sNsIgNxAV _0NUa3rhLcO _0Of8r25zaO _1Znuxb5zaO _1wydGW5zaO _2Zuz6Q5zaO _0KLXruDMqu _1ANEUSlpBW _3W2Oc8wPeg",
  filePreviewLoadingContainer: "_3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _4kiQYAHakr"
};
function isImageFileName(fileName: string): boolean {
  return /\.(png|jpe?g|gif|webp|svg|bmp|avif)$/i.test(fileName);
}
const TEXT_EXTENSIONS = ['.txt', '.md', '.markdown', '.json', '.xml', '.yaml', '.yml', '.js', '.jsx', '.ts', '.tsx', '.css', '.scss', '.less', '.html', '.htm', '.csv', '.log', '.sh', '.bash', '.py', '.rb', '.java', '.c', '.cpp', '.h', '.go', '.rs', '.sql'];
function getBlobPreviewKindFromFileName(fileName: string): 'image' | 'pdf' | 'text' | 'unknown' {
  const base = fileName.split(/[/\\]/).pop() ?? fileName;
  const lower = base.toLowerCase();
  if (isImageFileName(lower)) {
    return 'image';
  }
  if (TEXT_EXTENSIONS.some(ext => lower.endsWith(ext))) {
    return 'text';
  }
  return 'unknown';
}

/** Headers for authenticated Rovo file/blob fetches (gateway). `x-cloudid` is omitted when absent. */
export function buildRovoFileFetchHeaders(cloudId?: string): Record<string, string> {
  const headers: Record<string, string> = {
    'x-product': 'rovo',
    'x-experience-id': 'ai-mate'
  };
  if (cloudId) {
    headers['x-cloudid'] = cloudId;
  }
  return headers;
}
export type ScopeFileBlobPreviewModalProps = {
  isOpen: boolean;
  onClose: () => void;
  fileUrl: string;
  fileName: string;
  formatMessage: IntlShape['formatMessage'];
  /** i18n copy for non-previewable file types (e.g. PDF). */
  filePreviewFallbackDescription: MessageDescriptor;
  /** Cloud / site id for gateway `x-cloudid` on file preview fetches. */
  cloudId?: string;
};

/**
 * Modal that previews scope file / image blobs via authenticated `fetch` (gateway URLs),
 * including base64 text responses for images.
 */
export function ScopeFileBlobPreviewModal({
  isOpen,
  onClose,
  fileUrl,
  fileName,
  formatMessage,
  filePreviewFallbackDescription,
  cloudId
}: ScopeFileBlobPreviewModalProps): JSX.Element {
  const kind = getBlobPreviewKindFromFileName(fileName);
  const [textContent, setTextContent] = useState<string | null>(null);
  const [isLoadingText, setIsLoadingText] = useState(false);
  const [imageBlobUrl, setImageBlobUrl] = useState<string | null>(null);

  // Fetch text files with auth headers
  useEffect(() => {
    if (!isOpen || kind !== 'text') {
      return;
    }
    let cancelled = false;
    setIsLoadingText(true);
    fetch(fileUrl, {
      method: 'GET',
      headers: buildRovoFileFetchHeaders(cloudId),
      credentials: 'include'
    }).then(res => res.text()).then(text => {
      if (!cancelled) {
        setTextContent(text);
      }
    }).catch(() => {
      if (!cancelled) {
        setTextContent(null);
      }
    }).finally(() => {
      if (!cancelled) {
        setIsLoadingText(false);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [isOpen, kind, fileUrl, cloudId, fileName]);

  // Fetch images as blobs with auth headers (browsers don't support custom headers on <img src>).
  // We convert to a data URL via FileReader to satisfy CSP img-src policies.
  useEffect(() => {
    if (!isOpen || kind !== 'image') {
      return;
    }
    let cancelled = false;
    const ext = (fileName.split('.').pop() ?? '').toLowerCase();
    const MIME_BY_EXT: Record<string, string> = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      webp: 'image/webp',
      svg: 'image/svg+xml',
      bmp: 'image/bmp',
      ico: 'image/x-icon',
      avif: 'image/avif'
    };
    const mimeType = MIME_BY_EXT[ext] ?? 'application/octet-stream';
    type ImagePreviewPayload = {
      kind: 'blob';
      blob: Blob;
    } | {
      kind: 'text';
      text: string;
    };
    fetch(fileUrl, {
      method: 'GET',
      headers: buildRovoFileFetchHeaders(cloudId),
      credentials: 'include'
    }).then(async (res): Promise<ImagePreviewPayload> => {
      if (!res.ok) {
        throw new Error(`[ImagePreview] fetch failed with status ${res.status}`);
      }
      const contentType = res.headers.get('content-type') ?? '';
      const looksLikeBinary = contentType.startsWith('image/');
      if (looksLikeBinary) {
        const blob = await res.blob();
        return {
          kind: ('blob' as const),
          blob
        };
      }
      const text = await res.text();
      return {
        kind: ('text' as const),
        text
      };
    }).then((payload): Promise<string | null> => {
      if (cancelled) {
        return Promise.resolve(null);
      }
      if (payload.kind === 'text') {
        const b64 = payload.text.trim();
        return Promise.resolve(`data:${mimeType};base64,${b64}`);
      }
      const correctBlob = new Blob([payload.blob], {
        type: mimeType
      });
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve((reader.result as string));
        reader.onerror = e => reject(e);
        reader.readAsDataURL(correctBlob);
      });
    }).then(dataUrl => {
      if (!cancelled && dataUrl !== null) {
        setImageBlobUrl(dataUrl);
      }
    }).catch(err => {
      // eslint-disable-next-line no-console
      console.error('[ImagePreview] pipeline error:', err);
      if (!cancelled) {
        setImageBlobUrl(null);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [isOpen, kind, fileUrl, cloudId, fileName]);
  const renderBody = () => {
    if (kind === 'image') {
      if (!imageBlobUrl) {
        return <Box xcss={styles.filePreviewLoadingContainer}>
						<Spinner size="large" />
					</Box>;
      }
      return <Box as="img" src={imageBlobUrl} alt={fileName} xcss={styles.filePreviewImage} />;
    }
    if (kind === 'text') {
      if (isLoadingText) {
        return <Box xcss={styles.filePreviewLoadingContainer}>
						<Spinner size="large" />
					</Box>;
      }
      return <Box xcss={styles.filePreviewTextContent}>{textContent}</Box>;
    }
    return <Box xcss={styles.filePreviewFallback}>
				<Text size="medium" color="color.text.subtle">
					{formatMessage(filePreviewFallbackDescription)}
				</Text>
			</Box>;
  };
  return <ModalTransition>
			{isOpen && <Modal onClose={onClose} width="x-large" shouldScrollInViewport>
					<ModalHeader hasCloseButton>
						<ModalTitle>{fileName}</ModalTitle>
					</ModalHeader>
					<ModalBody hasInlinePadding={false}>{renderBody()}</ModalBody>
				</Modal>}
		</ModalTransition>;
}